module.exports = __webpack_public_path__ + "static/media/petshop.4c645897.png";